import { isMatch, parse, differenceInDays } from "date-fns";
import { useEffect, useState } from "react";
import { DATE_STRING_FORMAT } from "../../Constants/stringFormats";

export default function LengthOfStay(props) {
    const [los, setLos] = useState(1);

    useEffect(() => {
        if (!isMatch(props.fromDate, DATE_STRING_FORMAT) || !isMatch(props.toDate, DATE_STRING_FORMAT)) {
            setLos(1);
            return;
        }

        const nonCoveredDays = isNaN(props.nonCoveredDays) ? 0 : Number(props.nonCoveredDays);
        const calculatedLos = differenceInDays(parse(props.toDate, DATE_STRING_FORMAT, new Date()), parse(props.fromDate, DATE_STRING_FORMAT, new Date())) - nonCoveredDays;
        setLos(calculatedLos <= 0 ? 1 : calculatedLos);
    }, [props.fromDate, props.toDate, props.nonCoveredDays]);

    useEffect(() => {
        if (props.onChange) {
            props.onChange(los);
        }
    }, [los]);

    return (<span className="fw-bold">
        {los !== null && <>LOS {los} days</>}
    </span>);
}